b<template lang='pug'>
  div.map-tools
    div(type='flex' justify='flex-start')
      ods-cascader.map-tools__item(
        :options='districts'
        :placeholder="$t('Seleccionar')"
        @change='handleChange'
        v-if="verticalType === 'parksandgardens'"
        )
      ods-select.map-tools__item(
        v-if="$route.name == 'CRMDashboard'"
        v-model="categorySelected"
        :placeholder="$t('EligeCategoría')"
        @change='categoriesComplaintsChange'
        @visible-change='visibleChange')
        ods-option-group(
          v-for="item in gisDataByCategories"
          :key="item.label"
          :label="$t(item.label)")
          ods-option(
            v-for="item2 in item.options"
            :key="item2.value"
            :label="$t(item2.label)"
            :value="item2.value")
      ods-select.map-tools__item(
        v-else
        v-model='categorySelected'
        :placeholder="$t('EligeCategoría')"
        multiple
        collapse-tags
        @visible-change='visibleChange'
        @change='categoriesChange'
      )
        ods-option(
          v-for='item in gisDataByCategories'
          :key='item.value'
          :label='$t(item.label)'
          :value='item.value')

      ods-select.map-tools__item(
        v-if="filterActive"
        v-show="false"
        v-model='gisDataComplaintsSelected'
        :placeholder="$t('EligeCategoría')"
        multiple
        collapse-tags
        @visible-change='visibleChange'
        @change='categoriesChange')
        ods-option(
          v-for='item in gisDataComplaints'
          :key='item.value'
          :label='$t(item.label)'
          :value='item.value')
</template>

<script>

import jsonDistricts from '@/moks/las_palmas/parksandgardens/districts'

export default {
  name: 'MapToolsGeneric',
  data () {
    return {
      searchDirectionParks: '',
      categorySelected: [],
      gisDataByCategories: [],
      complaintsSelected: [],
      gisDataComplaintsSelected: ['presenceSolicitations', 'webSolicitations', 'appSolicitations'],
      gisDataComplaints: [{
        value: 'presenceSolicitations',
        label: 'Presence'
      }, {
        value: 'webSolicitations',
        label: 'Portal'
      }, {
        value: 'appSolicitations',
        label: 'App'
      }],
      districts: [],
      filterActive: false
    }
  },
  props: {
    verticalType: {
      type: String
    }
  },
  methods: {
    handleChange (value) {
      if (value[1]) {
        this.$emit('zoomParque', value[1])
      }
    },
    getFormatDistrictsAndParks () {
      let data = jsonDistricts
      let districts = []
      let option = {}
      let park = {}
      for (var i = 0; i < data.length; i++) {
        option = {
          value: data[i].id,
          label: data[i].name,
          children: []
        }
        for (var j = 0; j < data[i].parks.length; j++) {
          park = {
            value: data[i].parks[j].id,
            label: data[i].parks[j].name
          }
          option.children.push(park)
        }
        districts.push(option)
      }
      this.districts = districts
    },
    clearFilter () {
      this.categorySelected = []
      this.gisDataByCategories = []
    },
    visibleChange (status) {
      if (this.categorySelected === 'dataSourceSolicitations') {
        this.filterActive = true
      } else {
        this.filterActive = false
      }
    },
    categoriesChange (category) {
      const component = this
      for (var x = 0; x < component.gisDataByCategories.length; x++) {
        component.gisDataByCategories[x].show = false
      }
      if (category.length > 0) {
        for (var i = 0; i < category.length; i++) {
          for (var j = 0; j < component.gisDataByCategories.length; j++) {
            if (category[i] === component.gisDataByCategories[j].value) {
              component.gisDataByCategories[j].show = true
            }
          }
        }
      }
      // Actualizamos el filtro del vertical actual
      console.log('category select---->', category)
      this.$emit('updateFilter', category, component.gisDataByCategories)
      document.getElementById('dataIframe').contentWindow.activarDesactivarCapa(component.gisDataByCategories)
    },
    setToolsGeneric (category, categorySelected) {
      this.categorySelected = categorySelected
      this.gisDataByCategories = category
    },
    getDataCategory () {
      return this.gisDataByCategories
    },
    getCaterogySelected () {
      return this.categorySelected
    },
    categoriesComplaintsChange (data) {
      // const component = this
      this.loadDataFilter(data)
      this.loadDataFilterShow(data)
      this.$emit('controlLeyenda', data)
      this.$emit('updateFilter', data)
      // if (categoryInput !== 'dataSourceNumComplaints') {
      //   this.dataLegend(categoryInput)
      // } else {
      //   this.dataQuejas(categoryInput)
      // }
    },
    loadDataFilter (categoryInput) {
      let mapsHeatArray = document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers
      let valorCapa
      for (var i = 0; i < mapsHeatArray.length; i++) {
        if (mapsHeatArray[i]._imageryProvider.name) {
          valorCapa = mapsHeatArray[i]._imageryProvider.name.layerName
          if (categoryInput === valorCapa) {
            mapsHeatArray[i].show = true
          } else {
            mapsHeatArray[i].show = false
          }
        }
      }
    },
    loadDataFilterShow (categoryInput) {
      let mapsComplaintsArray = document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
      let valorCapa
      for (var i = 0; i < mapsComplaintsArray.length; i++) {
        valorCapa = mapsComplaintsArray[i].name.name
        if (categoryInput === valorCapa) {
          mapsComplaintsArray[i].show = true
        } else {
          mapsComplaintsArray[i].show = false
        }
      }
    },
    setToolsGenericComplaints (complaints, complaintsSelected) {
      this.complaintsSelected = complaintsSelected
      this.gisDataComplaints = complaints
    },
    getDatacomplaints () {
      return this.gisDataComplaints
    },
    getCaterogycomplaintsSelected () {
      return this.complaintsSelected
    }
  },
  created () {
    this.getFormatDistrictsAndParks()
  }
}
</script>

<style lang="scss" scoped>

  .map-tools {
    display: block;
    margin: 0;
    margin: rem(16) 0 0 rem(16);
    position: absolute;
    width: auto;
    z-index: 20;
    .ods-button {
      + .ods-button {
        margin-left: 0;
      }
    }
    .buttonBack {
      .ods-icon-arrow-left {
        margin-left: 0;
        font-size: 16px;
        margin-top: 0;
      }
    }
    &__item {
      display: inline-flex;
      margin: 0 rem(16) 0 0;
      min-width: rem(240);
      width: auto;
      &:last-child{
        margin-right: 0;
      }
    }
    /deep/ .ods-cascader .ods-cascader__relative-wrap{
      width: 100%;
    }
    /deep/ .ods-cascader__label{
      line-height: rem(24);
    }
    /deep/ .ods-cascader .ods-input__icon{
      margin-bottom: rem(2);
    }
  }

@media only screen and (min-width: 1920px){
  .map-tools {
    //SE QUITA PORQUE EN PANTALLAS GRANDES NO DEJA SELECCIONAR PUNTOS EN LA LINEA DEL SELECTOR
    // width: calc(75% - 104px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MapToolsGeneric.vue